import React from 'react';
import { I18N_DEFAULT_NAMESPACE } from '../constants';
import { useLocale } from './useLocale';
import { useI18N } from './useI18N';

export function useT() {
  const { locale } = useLocale();
  const i18n = useI18N();

  return React.useMemo(() => {
    const fixedT = i18n.getFixedT(locale, I18N_DEFAULT_NAMESPACE);

    return function wrappedT(
      id: string,
      stringValue: string,
      _description: string,
      interpolatedValues: { [key: string]: any } = {}
    ) {
      // fixedT function doesn't require `description` — we extract it later to send context to Smartling.
      return fixedT(id, stringValue, interpolatedValues);
    };
  }, [locale, i18n]);
}
